import { client } from '../client';
import { urls } from '../endpoints';
import {
  ApiResponse,
  CreateMultipleCourtType,
  CreateSportType,
  EditSportType,
  FacilitySportDto,
  SportLiteType,
  UpdateCourtType,
} from '../../types/types';

export const getSportsByFacilityIdRequest = async (facilityId: number) => {
  try {
    const response = await client.get<ApiResponse<FacilitySportDto[]>>(
      urls.getSportsByFacilityId(facilityId),
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSportsRequest = async (withImages?: boolean) => {
  try {
    const response = await client.get<ApiResponse<SportLiteType[]>>(
      urls.getSports,
      { params: { withImages } },
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const createFacilitySportRequest = async (
  sportData: CreateSportType,
) => {
  try {
    const response = await client.post<ApiResponse<number>>(
      urls.createFacilitySport(sportData.facilityId),
      sportData,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateFacilitySportRequest = async (sportData: EditSportType) => {
  try {
    const response = await client.put(
      urls.updateFacilitySport(sportData.facilityId, sportData.sportId),
      sportData,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const deleteFacilitySportRequest = async ({
  facilityId,
  sportId,
}: {
  facilityId: number;
  sportId: number;
}) => {
  try {
    const response = await client.delete<ApiResponse>(
      urls.deleteFacilitySport(facilityId, sportId),
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCourtRequest = async (court: UpdateCourtType) => {
  try {
    const response = await client.put<ApiResponse<number>>(
      urls.updateCourt(court.courtId),
      court,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createMultipleCourtsRequest = async (
  courts: CreateMultipleCourtType,
) => {
  try {
    const response = await client.post<ApiResponse<number>>(
      urls.createMultipleCourts(courts.facilitySportId),
      courts,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCourtRequest = async ({
  facilitySportId,
  courtId,
}: {
  facilitySportId: number;
  courtId: number;
}) => {
  try {
    const response = await client.delete<ApiResponse<number>>(
      urls.deleteCourt(facilitySportId, courtId),
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
